/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

export interface StudyNewsDetail {
    newsId: number;
    status: StudyNewsStatus;
    createdBy: string;
    createdDate: number;
    updatedDate: number;
    headline: string;
    subhead: string;
    leadParagraph: string;
    mainBody: string,
    mainBodyHtml: string;
    promoImage: string;
    promoCategory: string;
    sendNotification: boolean;
    sent: boolean;
}

export enum StudyNewsStatus {
    PUBLISHED = 'PUBLISHED',
    DRAFT = 'DRAFT',
    UNPUBLISHED = 'UNPUBLISHED'
}

export const defaultStudyNewsDetail: StudyNewsDetail = {
    newsId: 0,
    status: StudyNewsStatus.DRAFT,
    createdBy: '',
    createdDate: 0,
    updatedDate: 0,
    headline: '',
    subhead: '',
    leadParagraph: '',
    mainBody: '',
    mainBodyHtml: '',
    promoImage: '',
    promoCategory: '',
    sendNotification: false,
    sent: false
};